<template>
	<div class="col-12" v-if="is_idle">
		<div class="card bg-primary card-sm-stretch mb-2 mb-xl-2 px-6 py-2">
			<vue-countdown
				@end="redirectTo"
				:auto-start="true"
				:time="90000"
				v-slot="{ minutes, seconds }">
				<span class="text-white fw-bolder m-0">
					O sistema voltará para a tela de login após:
					<span v-if="minutes > 0"> {{ minutes }} minuto e </span>
					{{ seconds }} segundos.
				</span>
			</vue-countdown>
		</div>
	</div>
</template>

<script setup lang="ts">
	import VueCountdown from '@chenfengyuan/vue-countdown';
	import { Ref, onMounted, ref } from 'vue';
	import { browserWebcamStreamingStore } from '../../stores/browserWebcamStreaming';

	const props = defineProps({
		redirect_to: { type: String, required: true },
	});

	const is_idle = ref(false);
	const browserWebcam = browserWebcamStreamingStore();

	const user_activity_timeout = ref(null) as Ref<NodeJS.Timeout | null>;

	function resetUserActivityTimeout() {
		//@ts-ignore
		clearTimeout(user_activity_timeout.value);

		is_idle.value = false;

		user_activity_timeout.value = setTimeout(() => {
			inactiveUserAction();
		}, 10000);
	}

	function inactiveUserAction() {
		is_idle.value = true;
	}

	function activateActivityTracker() {
		window.addEventListener('mousemove', resetUserActivityTimeout);
		window.addEventListener('scroll', resetUserActivityTimeout);
		window.addEventListener('keydown', resetUserActivityTimeout);
		window.addEventListener('resize', resetUserActivityTimeout);
	}

	function redirectTo() {
		browserWebcam.stop('exam-feedback-idle');
		window.location.href = props.redirect_to;
	}

	onMounted(() => {
		activateActivityTracker();
	});
</script>
